// extracted by mini-css-extract-plugin
module.exports = {"menuLink":"menuItem-module--menuLink--3em61","burgerLink":"menuItem-module--burgerLink--30ila","landing":"menuItem-module--landing--tQLMI"};